import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { PointoramaStructure } from '../../../../potree/utils/PointoramaStructure';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Annotation = Project['state']['annotations'][number];

export function createSyncStructuresConfig({ viewer, annotations, groups }: { viewer: NonNullable<RendererContextType['viewer']>; annotations: Annotation[]; groups: Project['state']['groups'] }): SyncConfig<Annotation, PointoramaStructure> {
  return {
    getSourceItems: () => annotations.filter((a) => a.type === 'STRUCTURE'),
    getSceneItems: () => [...viewer.scene.structures],
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    // update() omitted — geometry updates flow through reactive property subscriptions
    create: (source) => {
      const structure = new PointoramaStructure(viewer);
      structure.identifier = source.identifier;
      structure.groupName = groups.find((g) => g.identifier === source.groupIdentifier)?.name ?? '';
      structure.groupIdentifier = source.groupIdentifier || null;
      structure.finished = true;
      return structure;
    },
    addToScene: (item) => viewer.scene.addStructure(item),
    removeFromScene: (item) => viewer.scene.removeStructure(item),
  };
}
